import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './no-results.component.scss',
})
export class NoResultsComponent {
  @Input() message: string;
}
